import { atom } from 'recoil';

export const hasNewBookAtom = atom({
  key: 'hasNewBookAtom',
  default: false,
});
